import http from "../../../core/utils/apis/api";

const getTrainingDetails = async (trainingId) => {
  try {
    if (trainingId) {
      const response = await http({
        method: "GET",
        url: `/trainings/${trainingId}`,
      });
      return response.data;
    }
    return;
  } catch (e) {
    throw e;
  }
};

const trainingDetailsService = {
  getTrainingDetails,
};

export default trainingDetailsService;
